<div id="{{'category_' + therapyMatchCategory}}" class="Flexbox Spacebox__tiny aberration-details_content" *ngFor="let therapyMatchCategory of therapyMatchCategories">
  <div class="extra-detail-category" translate>{{'therapyMatch.' + therapyMatchCategory}}</div>
  <div [ngSwitch]="therapyMatchCategory">
    <div *ngSwitchCase="'curationTherapyMatcher'">
      <curation-therapy-match
        [configuration]="configuration?.therapyMatches?.curationTherapyMatcher"
        [therapyMatches]="therapyMatches['curationTherapyMatcher']">
      </curation-therapy-match>
    </div>
  </div>
</div>

<div id="{{'category_' + annotationCategory}}" class="Flexbox Spacebox__tiny aberration-details_content" *ngFor="let annotationCategory of annotationsCategories">
  <div class="extra-detail-category">{{annotationCategory}}</div>
  <div [ngSwitch]="annotationCategory">
    <data-table *ngSwitchCase="'annotation.transcripts' | translate"
                [columnsData]="reMapTranscriptsItem(aberrationExtras['annotation.transcripts' | translate].annotations)"
                [configuration]="configuration?.transcriptsDataTable"
                [translationPrefix]="'annotation'"></data-table>
    <ng-container *ngSwitchDefault>
      <ng-container *ngIf="annotationsFormExists(annotationCategory)">
        <gen-editable-annotation
                [testConfig]="testTableData"
                [aberration]="aberration"
                [currentModality]="currentModality"
                [annotations]="aberrationExtras[annotationCategory]"
                (annotationUpdated)="infoContentUpdated($event)"
        >
        </gen-editable-annotation>
      </ng-container>
      <ng-container *ngIf="!annotationsFormExists(annotationCategory)">
        <key-value-card
                [configuration]="configuration"
                [data]="aberrationExtras[annotationCategory].annotations"
                [translationPrefix]="'annotation'"
                [additionKeyValueItemsResolverRef]="resolveAdditionKeyValueItems">
        </key-value-card>
      </ng-container>
    </ng-container>
  </div>
</div>

<div id="{{'category_' + clinicalTrialCategory}}" class="Flexbox Spacebox__tiny aberration-details_content" *ngFor="let clinicalTrialCategory of clinicalTrialCategories">
  <div class="extra-detail-category" translate>{{'clinicalTrials.' + clinicalTrialCategory}}</div>
  <div [ngSwitch]="clinicalTrialCategory">
    <div *ngSwitchCase="'curationClinicalTrialProvider'">
      <key-value-card *ngFor="let item of clinicalTrials['curationClinicalTrialProvider']"
                      [columns]="2"
                      [configuration]="configuration?.clinicalTrials?.curationClinicalTrialProvider"
                      [isCard]="true"
                      [translationPrefix]="'clinicalTrials'"
                      [data]="reMapClinicalTrialItem(item)"
                      [additionKeyValueItemsResolverRef]="resolveAdditionKeyValueItems">
      </key-value-card>
    </div>
  </div>
</div>
